// extracted by mini-css-extract-plugin
module.exports = {"insertTable":"styles_insertTable__FEGGL","insertText":"styles_insertText__7UCdy","tocLeft":"styles_tocLeft__pDT0u"};